// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"120":"314f0ff4","230":"cd148fad","846":"6c2920cc","995":"b2aa14dc"}[chunkId] + ".js";
};